import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/siteInfo/About.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/siteInfo/Privacy.vue')
    },
    {
      path: '/articles',
      name: 'articles',
      component: () => import('./views/Articles.vue')
    },
    {
      path: '/article/:id',
      name: 'article',
      component: () => import('./views/Article.vue')
    },
    {
      path: '/caseList',
      name: 'caseList',
      component: () => import('./views/CaseList.vue')
    },
    {
      path: '/case/:id',
      name: 'case',
      component: () => import('./views/Case.vue')
    },
    {
      path: '/themeList',
      name: 'themeList',
      component: () => import('./views/ThemeList.vue')
    },
    {
      path: '/:id',
      name: 'theme',
      component: () => import('./views/Theme.vue')
    },
    {
      path: '/keywords/:id',
      name: 'keywords',
      component: () => import('./views/Keywords.vue')
    },
    {
      path: '/initial/:id',
      name: 'initial',
      component: () => import('./views/Initial.vue')
    },
    {
      path: '/category/:id',
      name: 'category',
      component: () => import('./views/Category.vue')
    },
    {
      path: '/question',
      name: 'question',
      component: () => import('./views/Question.vue')
    },
    {
      path: '/content/:id',
      name: 'content',
      component: () => import('./views/Content.vue')
    },
    {
      path: '/makejson/',
      name: 'makejson',
      component: () => import('./views/MakeJson.vue')
    },

  ]
})
